/**
 * 首页路由配置（证书核验）
 */
export default {
  path: '/home/info-search/license-verify',
  name: 'license-verify',
  component: () => import('../../views/license-verify'),
  meta: {
    label: '证书核验',
    isNotMenu: true,
    icon: require('../../assets/images/zshy.png'),
    activeMenu: '/home/license-verify',
    permission: 'IEBDC:SY:XXCX:JDCX',
    construction: 'IEBDC:SY:XXCX:JDCX:SFZJ',
    icon: 'iconzhengjian',
    background: 'linear-gradient(to bottom right, #37A3FD , #2367F1)'
  }
};
